import { JAR_TYPE_ORDER } from '../components/three/jarMeta';
import { logWarn } from './log';

export const OBJECTIVES = [
  { id: 'hydra', color: 'blue', effects: ['Idratante', 'Nutriente', 'Protettivo', 'Riparante', 'Rigenerante'] },
  { id: 'antiage', color: 'pink', effects: ['Anti-age', 'Lifting', 'Tensore', 'Levigante', 'Rigenerante'] },
  { id: 'glow', color: 'orange', effects: ['Illuminante', 'Energizzante', 'Rivitalizzante', 'Anti-occhiaie', 'Volumizzante'] },
  { id: 'pure', color: 'green', effects: ['Purificante', 'Matificante', 'Detox', 'Drenante', 'Decongestionante', 'Levigante'] },
  { id: 'repair', color: 'pink', effects: ['Riparante', 'Rigenerante', 'Nutriente', 'Protettivo', 'Idratante'] },
];

export const splitEffects = (p) => (p?.effect || p?.benefit || '').split(',').map((s) => s.trim()).filter(Boolean);

export const kitFunctionOf = (items) => {
  const counts = new Map();
  items.forEach((p) => splitEffects(p).forEach((e) => counts.set(e, (counts.get(e) || 0) + 1)));
  const top = [...counts.entries()].sort((a, b) => b[1] - a[1]).slice(0, 2).map(([e]) => e.toUpperCase());
  return top.length ? `KIT ${top.join(' // ')}` : '';
};

export const composeKit = (products, objective) => {
  const weights = new Map(objective.effects.map((e, i) => [e.toLowerCase(), objective.effects.length - i]));
  const slots = {};
  JAR_TYPE_ORDER.forEach((type) => {
    let best = null;
    let bestScore = -1;
    products.filter((p) => p.product_type === type).forEach((p) => {
      const score = splitEffects(p).reduce((s, e) => s + (weights.get(e.toLowerCase()) || 0), 0) + Math.random() * 0.5;
      if (score > bestScore) { best = p; bestScore = score; }
    });
    slots[type] = best;
  });
  return slots;
};

const KEY = 'beautykit_last_mix';

export const saveLastKit = (items, meta = {}) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      name: meta.name || '',
      fn: meta.fn || kitFunctionOf(items),
      ts: Date.now(),
      total: items.reduce((s, p) => s + (p.price || 0), 0),
      items: items.map((p) => ({ id: p.id, product_type: p.product_type, line_color: p.line_color, main_ingredient: p.main_ingredient, effect: p.effect || p.benefit, image_url: p.image_url, price: p.price || 0 })),
    }));
  } catch (error) {
    logWarn('Could not save last kit:', error);
  }
};

export const readLastKit = () => {
  try {
    const kit = JSON.parse(localStorage.getItem(KEY) || 'null');
    return kit && Array.isArray(kit.items) && kit.items.length === 5 ? kit : null;
  } catch (error) {
    logWarn('Could not read last kit:', error);
    return null;
  }
};
